import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";

function RequireAuth() {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const { isAuth, loading, isSessionExpired } = useAuth();

    useEffect(() => {
        if (params.get("ex")) {
            // ToDo: Check. Old Auth was here
            navigate(location.pathname, { replace: true });
        }
    }, []);

    if (loading) return null;

    if (!isAuth && !isSessionExpired) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}

export default RequireAuth;
